import React from 'react'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { css, cx } from '@emotion/css'
import { CsCheckIcon } from './check-icon'

const checkmarkIconCss = css`
  font-size: 20px;
  color: ${theme.color.green50};
`

export function CheckmarkIcon({
  className,
  size,
  testId
}: {
  className?: string
  size?: number
  testId?: string
}) {
  return (
    <CsCheckIcon
      data-testid={testId}
      size={size}
      className={cx(checkmarkIconCss, className)}
    />
  )
}
